module.exports = __webpack_public_path__ + "img/logo.e3c87ee5.png";